/* Product description videos load only after an explicit play action. */
(() => {
  'use strict';
  if (customElements.get('gobaby-video')) return;
  customElements.define('gobaby-video', class extends HTMLElement {
    connectedCallback() {
      if (this.onPlay) return;
      const link = this.querySelector('.gobaby-video-play');
      const template = this.querySelector('template');
      const source = template && template.content.querySelector('iframe');
      if (!link || !source) return;
      let url;
      try { url = new URL(source.getAttribute('src'), document.baseURI); }
      catch { return; }
      if (url.protocol !== 'https:' ||
          !['youtube.com', 'www.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(url.hostname) ||
          !/^\/embed\/[\w-]+$/.test(url.pathname)) return;
      this.onPlay = event => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const frame = source.cloneNode(true);
        url.searchParams.set('autoplay', '1');
        frame.src = url.href;
        frame.title = source.title || 'Video del producto';
        frame.loading = 'eager';
        frame.setAttribute('allow', (source.getAttribute('allow') || '') + '; autoplay; fullscreen');
        frame.setAttribute('allowfullscreen', '');
        this.replaceChildren(frame);
        frame.focus();
        this.dispatchEvent(new Event('resize', { bubbles: true }));
      };
      link.addEventListener('click', this.onPlay);
    }
  });
})();
